import React from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  return <section className="w-full py-24 px-6 bg-[#0a0f0d]" data-id="element-93">
      <div className="max-w-2xl mx-auto space-y-24" data-id="element-94">
        {/* Es para ti si... */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="space-y-8" data-id="element-95">
          <h2 className="text-3xl md:text-4xl font-bold text-[#f0f0f0]" data-id="element-96">
            EBOOK CREATOR es para ti si…
          </h2>

          <ul className="space-y-4 text-lg text-gray-400 leading-relaxed" data-id="element-97">
            {['Quieres lanzar tu primer producto digital en formato ebook, pero no sabes por dónde empezar.', 'Tienes conocimiento, pero te falta estructura, enfoque y una promesa clara.', 'Ya probaste ChatGPT y solo obtuviste texto suelto (no un producto vendible).', 'Te abruma escribir y diseñar, y necesitas una guía paso a paso.', 'Quieres un ebook que se vea profesional y represente tu marca personal.', 'Necesitas una forma simple de crear un activo que puedas vender hoy y mejorar con el tiempo.'].map((item, i) => <li key={i} className="flex items-start space-x-3" data-id="element-98">
                <span className="w-2 h-2 mt-2.5 bg-[#00d4aa] rounded-full flex-shrink-0" data-id="element-99" />
                <span data-id="element-100">{item}</span>
              </li>)}
          </ul>
        </motion.div>

        {/* Divider */}
        <div className="w-24 h-px bg-[#00d4aa]/30 mx-auto" data-id="element-101" />

        {/* El Problema */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="space-y-8" data-id="element-102">
          <h2 className="text-3xl md:text-4xl font-bold text-[#f0f0f0]" data-id="element-103">
            No te falta talento. Te falta orden.
          </h2>

          <div className="space-y-6 text-lg text-gray-400 leading-relaxed" data-id="element-104">
            <p data-id="element-105">La mayoría no publica su ebook porque:</p>

            <ul className="space-y-3 pl-4 border-l border-gray-800" data-id="element-106">
              <li data-id="element-107">
                — empieza a escribir sin definir avatar, promesa y objetivo,
              </li>
              <li data-id="element-108">— salta entre plantillas y consejos contradictorios,</li>
              <li data-id="element-109">
                — usa IA sin método y termina con contenido repetido o sin
                dirección,
              </li>
              <li data-id="element-110">— se queda corrigiendo y nunca lo lanza.</li>
            </ul>

            <p className="text-xl text-white font-bold border-l-4 border-[#00d4aa] pl-6 py-2 mt-8" data-id="element-111">
              EBOOK CREATOR te da un sistema para terminar.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}